import React, { Component } from 'react';
import {
  List,
  Update,
  Delete,
  Get,
  ListEvents,
  ListCompetitionUsers
} from './graphql.js';
import WorkshopsComponent from '../../components/Workshops';
import {
  adminQuery,
  adminMutation,
  logError,
  parseAwsJson,
  updateInPath
} from '../../../../common/utils';
import { getList } from '../../../common/utils';
import { clone } from 'ramda';


// END config
export default class Workshops extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      events: []
    };

    this.filter = {};
  }
  
  fetchFilterOptions = async () => {
    const data = await getList('listEvents', { query: ListEvents });
    this.setState(s => updateInPath(s, 'events', data));
  }


  fetchData = async (filter) => {
    if (filter) {
      this.filter = clone(filter);
    }

    this.setState(s => updateInPath(s, 'loading', true));

    const data = await getList('listWorkshops', {
      query: List,
      variables: { filter: (filter || this.filter) }
    }, ['userData']);

    this.setState(s => updateInPath(s, 'data', data));
    this.setState(s => updateInPath(s, 'loading', false));
  }

  // TODO refactor and split to multiple functions
  onDownloadWorkshopsCsv = (competitionId, callback) => {
    adminQuery(ListCompetitionUsers, { competitionId: competitionId})
      .then(({listCompetitionUsers: users}) => {
        callback(users);
      })
      .catch(logError);
  }

  handleWorkshopSave = (formData) => {
    const data = clone(formData);

    // TODO: see utils->toAwsJson text
    data.userData = JSON.stringify(data.userData);
    delete data.user;

    adminMutation(
      data,
      [
        { from: 'competition', to: 'competitionId' },
        { from: 'event', to: 'eventId' }
      ],
      Update,
      () => { this.fetchData(); }
    );
  }

  handleWorkshopDelete = (workshopId, userId) => {
    adminMutation(
      { workshopId: workshopId, userId: userId },
      [],
      Delete,
      () => {  this.fetchData(); });
  }
  
  handleWorkshopGet = (workshopId, userId, callback) => {
    adminQuery(Get, { workshopId: workshopId, userId: userId })
      .then(({ getWorkshop: workshop }) =>
            callback(parseAwsJson(workshop, ['userData'])))
      .catch(logError);
  };

  componentDidMount = () => {
    this.fetchFilterOptions();
  }

  render() {
    const { data, events, loading } = this.state;
    
    return (
      <WorkshopsComponent
        data={data}
        events={events}
        refresh={this.fetchData}
        onDownloadWorkshopsCsv={this.onDownloadWorkshopsCsv}
        onWorkshopDelete={this.handleWorkshopDelete}
        onWorkshopView={this.handleWorkshopGet}
        onWorkshopSave={this.handleWorkshopSave}
        loading={loading}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/private/admin/containers/Workshops/index.js